import request from "@/utils/request";
export function column(data) {
    return request({
        url: '/api/portal/v1/portal/queryForPage',
        method: 'post',
        data
    })
}

export function hycase(data) {
    return request({
        url: '/api/portal/v1/portal/selectColumnNewsInfo',
        method: 'post',
        data
    })
}